import { theme } from "@tm/utility/global";
import styled from "styled-components";
import { FlexCompStyle } from "../../../../components/FlexComp/FlexComp.style";
import { deviceType } from "../../../../utils";

// ── Grid variant (MMT) ─────────────────────────────────────────────────────

export const OrderDataTableGrid = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  border: 1px solid ${theme.gainsBoro};
  border-radius: 12px;
  ${FlexCompStyle} {
    :nth-child(n + 3) {
      border-bottom: none;
    }
    :nth-child(3) {
      border-right: none;
      border-bottom: 1px solid ${theme.gainsBoro};
    }
  }
  @media ${deviceType.mobile} {
    display: flex;
    flex-direction: column;
    border: none;
    ${FlexCompStyle} {
      border-bottom: 1px solid ${theme.gainsBoro};
      padding: 12px 0;
      border-right: none;
      :nth-child(n + 3) {
        border-bottom: 1px solid ${theme.gainsBoro};
      }
      :last-child {
        border-bottom: none;
      }
    }
  }
`;

export const OrderDataTableItem = styled(FlexCompStyle)`
  border-right: 1px solid ${theme.gainsBoro};
  border-bottom: 1px solid ${theme.gainsBoro};
  padding: 12px;
  word-break: normal;
  overflow-wrap: break-word;
  :last-child {
    border-right: none;
  }
  @media ${deviceType.mobile} {
    display: flex;
    justify-content: space-between;
  }
`;

// ── Stacked variant (GI) ───────────────────────────────────────────────────

export const StackedTableList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StackedTableItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 0;
  border-bottom: 1px solid ${theme.gainsBoro};
`;
